/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumMessageStatus = "delivered" | "opened" | "pending" | "sent" | "skipped" | "undelivered" | "%future added value";
export type IconMessageStatus_Message = {
    readonly status: EnumMessageStatus | null;
    readonly statusReason: string | null;
    readonly externalStatus: {
        readonly reason: string | null;
    } | null;
    readonly " $refType": "IconMessageStatus_Message";
};
export type IconMessageStatus_Message$data = IconMessageStatus_Message;
export type IconMessageStatus_Message$key = {
    readonly " $data"?: IconMessageStatus_Message$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"IconMessageStatus_Message">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IconMessageStatus_Message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageExternalStatus",
      "kind": "LinkedField",
      "name": "externalStatus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};
(node as any).hash = '8188a7c8e9a42e4d88e32d2468d44a3a';
export default node;
